import { useEffect, useRef, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetRoles } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { FaPlus } from "react-icons/fa";
import { rolesColumns } from "../../lib/definitions";
import { deleteRolesForm } from "../../lib/actions";
import DeleteRecord from "../../ui/Models/deleteRecord";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import i18n from "../../lib/i18n";

export default function Roles() {

    const [rolesData, setRolesData] = useState([]);
    const deleteRef = useRef(null);
    const [deleteConfirmation, setDeleteConfirmation] = useState({ isOpen: false, idToDelete: null });
    const [isLoading, setIsLoading] = useState(true);  
    const [loadingDelete, setLoadingDelete] = useState(false);  
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
            deleteRef.current && 
            !deleteRef.current.contains(event.target)
            ) {
            closeDeleteConfirmation();
            }
        };

        if (deleteConfirmation.isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [deleteConfirmation.isOpen]);


    const handleApi = async () => {
        setIsLoading(true);  
        const roleData = await GetRoles();
        console.log(roleData);
        setRolesData([]);
        roleData.map((e) => setRolesData((prev) => [...prev, e]));
        setIsLoading(false);  
    };

    const openDeleteConfirmation = (id) => {
        setDeleteConfirmation({ isOpen: true, idToDelete: id });
    };

    const closeDeleteConfirmation = () => {
        setDeleteConfirmation({ isOpen: false, idToDelete: null });
    };

    const handelDelete = async () => {
        if (deleteConfirmation.idToDelete) {
            setLoadingDelete(true);
            const result = await deleteRolesForm(deleteConfirmation.idToDelete);
            if (result) {
                setLoadingDelete(false);
                handleApi();
            }
            closeDeleteConfirmation();
        }
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
            <div className="flex flex-col sm:flex-row sm:items-baseline bg-thirdly  justify-between px-5 py-5  gap-4">
                <h1 className="text-white text-lg ">{t("nav.roles")}</h1>
                <Button background="#D36300" borderRadius="8px" color="white" padding="8px 20px" text={t("button.add_roles")} nav={"/roles/add"}  />
            </div>
            <div>
                {isLoading ? <TableSkeleton cols={rolesColumns}/> : (  
                    <Table columns={rolesColumns} rows={rolesData} openDeleteConfirmation={openDeleteConfirmation} action={"permissions"} edit="/roles/edit" />
                )}  
            </div>
            {deleteConfirmation.isOpen && <DeleteRecord ref={deleteRef} loadingDelete={loadingDelete} handelDelete={handelDelete} closeDeleteConfirmation={closeDeleteConfirmation} />}
        </div>
    );
};